<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">All Accounting Entries</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <AllAccountingEntriesTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../../router/layouts/main";
import PageHeader from "../../../components/AppComponents/page-header";
import AllAccountingEntriesTable from "../../../components/Kleyton/Tables/Product/AccountingEntry/AllAccountingEntriesTable";

export default {
  name: "AllAccountingEntries",
  page: {
    title: "Accounting Entry",
    meta: [{ name: "Accounting Entry", content: window.__env.app.description }]
  },
  components: {
    AllAccountingEntriesTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "Accounting Entry",

      items: [
        {
          text: "Accounting Entry",
          href: "/"
        },
        {
          text: "All",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
